import BankService from '@/store/services/bank.service.js';
import TinkService from '@/store/services/tink.service.js';

export default {
  namespaced: true,
  state: {
    tinkStatus: null,
    bankAccounts: [],
    selectedAccount: null
  },
  getters: {
    getTinkStatus: state => state.tinkStatus,
    getTinkCredentials: state => state.tinkStatus.tink_connection.tinkcredential_set,
    getBankAccount: state => id => state.bankAccounts.find(item => item.id === id),
    getBankAccounts: state => state.bankAccounts,
    getSelectedAccount: state => state.selectedAccount,
  },
  mutations: {
    SET_TINK_STATUS (state, value) {
      state.tinkStatus = value
    },
    SET_BANK_ACCOUNTS (state, value) {
      state.bankAccounts = value
    },
    SET_SELECTED_ACCOUNT (state, value) {
      state.selectedAccount = state.bankAccounts.find(item => item.id === value)

      if (!state.selectedAccount) {
        state.selectedAccount = null;
      } else {
        BankService.getBankAccountStatus(state.selectedAccount.id).then((response) => {
          state.tinkStatus = response.data;
        });
      }
    },
    DELETE_BANK_ACCOUNT (state, account_id) {
      state.bankAccounts = state.bankAccounts.filter(account => account.id !== account_id)
      if (account_id === state.selectedAccount.id && state.bankAccounts.length > 0) {
        state.selectedAccount = state.bankAccounts[0]
      }
      if (state.bankAccounts.length === 0) {
        state.selectedAccount = null
      }
    }
  },
  actions: {
    loadBankAccounts ({ commit }) {
      return BankService.list({ extended: true, company_profile: window.company_id }).then((response) => {
        commit('SET_BANK_ACCOUNTS', response.data)
      })
    },
    deleteBankAccount ({ commit, state }, account_id) {
      return BankService.destroy(account_id).then(() => {
        commit('DELETE_BANK_ACCOUNT', account_id)
        commit('filterStore/SET_BANK_ACCOUNT', (state.selectedAccount) ? state.selectedAccount.id : null, { root: true })
        commit('filterStore/SET_COOKIES', null, { root: true })
        commit('filterStore/SET_UPDATE_FILTER_BANK', null, { root: true })
      })
    },
    loadTinkStatus ({ commit }) {
      TinkService.status().then((response) => {
        commit('SET_TINK_STATUS', response.data)
      })
    },
    updateTransactions ({ state, commit }) {
      if (state.selectedAccount.tink_credential) { // Gives priority to Tink if Unifiedpost is also present
        TinkService.refreshCredentials(state.selectedAccount.tink_credential.id).then((response) => {
          window.location.href = response.data;
        }).catch((response) => {
          if (response.data && response.data.minutes_left) {
            let credential_error = this.getters.getRoot.$gettext('Please wait %(minutes) more minutes until your refresh')
            const temp = this.getters.getRoot.$gettext('Your bank will not allow multiple account requests in a row, wait for a couple minutes before refreshing again.')
            credential_error = temp + credential_error.replace('%(minutes)', response.data.minutes_left)
            commit('setAlert', {
              title: this.getters.getRoot.$gettext('Too many requests'),
              text: credential_error,
              variant: 'warning',
              duration: 4
            }, { root: true })
          } else {
            commit('setAlert', {
              title: this.getters.getRoot.$gettext('Something went wrong'),
              text: this.getters.getRoot.$gettext('Please try again later'),
              variant: 'danger',
              duration: 4
            }, { root: true })
          }
        })
      } else if (state.selectedAccount.unifiedpostpaymentaccount) { 
        let params = {'payment_account_id': state.selectedAccount.unifiedpostpaymentaccount.payment_account_id}
        
        return BankService.requestRefreshAccountMovements(params).then(() => {
          return 'refreshData'
        });
      } else {
        return 'showModal'
      }
    }
  }
}
